/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { V1ReportRunStatus } from '../models/V1ReportRunStatus';
import { HttpFile } from '../http/http';

/**
* ReportRun is a single execution of a Report. Runs are created by RunReport (manual), should_run_now on CreateReport (manual), RetryReportRun (manual, from a FAILED source run), or automatically when a Schedule's configured cadence is reached (scheduled). DownloadReportRun returns a signed URL for the generated file when status = SUCCESS; RetryReportRun creates a new run from a FAILED one.
*/
export class V1ReportRun {
    /**
    * Server-assigned run identifier.
    */
    'id'?: string;
    /**
    * Owning organization.
    */
    'orgId'?: string;
    /**
    * The report this run belongs to.
    */
    'reportId'?: string;
    /**
    * schedule_id is only populated for runs triggered by a Schedule. For manual runs, this field is empty.
    */
    'scheduleId'?: string;
    'status'?: V1ReportRunStatus;
    /**
    * Stats start time.
    */
    'statsStartTime'?: Date;
    /**
    * Stats end time.
    */
    'statsEndTime'?: Date;
    /**
    * Server-assigned creation time.
    */
    'createTime'?: Date;
    /**
    * Server-assigned last-update time.
    */
    'updateTime'?: Date;
    /**
    * Set when the resource has been deleted; null otherwise.
    */
    'deleteTime'?: Date;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "orgId",
            "baseName": "org_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "reportId",
            "baseName": "report_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "scheduleId",
            "baseName": "schedule_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "V1ReportRunStatus",
            "format": ""
        },
        {
            "name": "statsStartTime",
            "baseName": "stats_start_time",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "statsEndTime",
            "baseName": "stats_end_time",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "createTime",
            "baseName": "create_time",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "updateTime",
            "baseName": "update_time",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "deleteTime",
            "baseName": "delete_time",
            "type": "Date",
            "format": "date-time"
        }    ];

    static getAttributeTypeMap() {
        return V1ReportRun.attributeTypeMap;
    }

    public constructor() {
    }
}

